import React from 'react';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import AppBar from '../../commons/AppBar'
import { Grid, TextField, Button, FormControl, InputLabel, Select, Input, MenuItem, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import FromServer from './FromServer';


export default class RapoarteTimp extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataStart: new Utils().defaultDataMinus1Months(),
            dataFinish: new Utils().defaultData(),
            sortBy: 'nume_user', //aceleasi ca cheile obiectului analize1,
            listRaport: [],
            sortByList: new Utils().sortByTasksReport,
            chartData: [],
            chartData2: [],
            listProjects: [],
            listUsers: [],
            listUsersAll: [],
            listProjectsAll: [],
            numeProiect: 1,
            numeUser: 1
        }
    }

    componentDidMount() {

    }

    getRaport = async () => {
     
        let fs = new FromServer();

        let getRaport = await fs.getRaportTimp()

        if(getRaport.r){

            this.listRaportGroupedByUser = getRaport.c.userRez


            this.sortDs(getRaport.c.u, getRaport.c.p)
        

        }


    }

    sortBy = (ev) => {
        this.setState({ sortBy: ev.target.value }, () => {
            this.sortDs(this.state.listUsersAll, this.state.listProjectsAll)
        })
    }

    sortDs = (u, p) => {

        let s = this.listRaportGroupedByUser.sort((a, b) => {
            if (a[this.state.sortBy] < b[this.state.sortBy]) {
                return -1
            };
            return 1
        })

        let filteredList = s.filter((_s) => {
            if (this.state.listUsers.length === 0) { return true; }

            for (let i = 0, n = this.state.listUsers.length; i < n; i++) {

                if (_s.id_utilizator_responsabil === this.state.listUsers[i].id) {
                    return true;
                   
                }
            }

        })

        filteredList = filteredList.filter((pr) => {
            if (this.state.listProjects.length === 0) { return true; }

            for (let i = 0, n = this.state.listProjects.length; i < n; i++) {
                if (pr.id_proiect === this.state.listProjects[i].id) {
                    return true;
                   
                }
            }
        })

        // console.log('filteredList :', filteredList);



        this.setState({
            listRaport: filteredList,
            listUsersAll: u,
            listProjectsAll: p

        }, () => {
            // console.log('this.state.listRaport :', this.state.listRaport);
        })
    }

    

    addUser=(ev)=>{
            let cloneUsers = [...this.state.listUsersAll]

            let idx = cloneUsers.findIndex(i => i.id === ev.target.value)

           

            let usersToAdd = [...this.state.listUsers]

            usersToAdd.push(cloneUsers[idx])
            cloneUsers.splice(idx,1)
            this.setState({listUsers:usersToAdd},()=>{
                this.sortDs(cloneUsers, this.state.listProjectsAll)
            })
    }

    addProiect =(ev)=>{
        let cloneProiecte = [...this.state.listProjectsAll]

            let idx = cloneProiecte.findIndex(i => i.id === ev.target.value)

           

            let projectsToAdd = [...this.state.listProjects]

            projectsToAdd.push(cloneProiecte[idx])

            // console.log('projectsToAdd :', projectsToAdd);
            cloneProiecte.splice(idx,1)
            this.setState({listProjects:projectsToAdd},()=>{
                this.sortDs(this.state.listUsersAll, cloneProiecte)
            })
    }

    removeFilterProiect = (p) =>{
        let cloneProiecte = [...this.state.listProjects]

        let idx = cloneProiecte.findIndex(i => i.id === p.id)

       

        let projectsToAdd = [...this.state.listProjectsAll]

        projectsToAdd.push(cloneProiecte[idx])

        // console.log('projectsToAdd :', projectsToAdd);
        cloneProiecte.splice(idx,1)
        this.setState({listProjects:cloneProiecte},()=>{
            this.sortDs(this.state.listUsersAll, projectsToAdd)
        })
    }

    removeFilterUser = (u) =>{
        let cloneUsers = [...this.state.listUsers]

        let idx = cloneUsers.findIndex(i => i.id === u.id)

           

        let usersToAdd = [...this.state.listUsersAll]

        usersToAdd.push(cloneUsers[idx])
        cloneUsers.splice(idx,1)
        this.setState({listUsers:cloneUsers},()=>{
            this.sortDs(usersToAdd, this.state.listProjectsAll)
        })

    }


    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.rapoarte} />


                <div className='container'>
                    <h2 className='pm-title'>Analiza Timpului</h2>
                    <Grid container>


                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label={this.dictionary.proiecte.informatiiProiect.deLa}
                                value={this.state.dataStart || ''}
                                onChange={(ev) => { this.setState({ dataStart: ev.target.value }) }}
                                margin="normal"
                                type='date'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label={this.dictionary.proiecte.informatiiProiect.panaLa}
                                value={this.state.dataFinish || ''}
                                onChange={(ev) => { this.setState({ dataFinish: ev.target.value }) }}
                                margin="normal"
                                type='date'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Button variant="outlined" onClick={this.getRaport} className='pm-save-button'>
                                Executa
                            </Button>
                        </Grid>



                    </Grid>
                </div>


                {this.state.listRaport.length > 0 &&
                    <div className='container' style={{ textAlign: 'right', }}>
                        <Grid container style={{ marginBottom: 50 }}>


                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <FormControl className='inputFocus' >
                                    <InputLabel htmlFor="resursa">{this.dictionary.proiecte.numeProiect}</InputLabel>
                                    <Select

                                        value={this.state.numeProiect || ""}
                                        onChange={(ev) => { this.addProiect(ev) }}

                                        input={<Input id="resursa" />}>


                                        {this.state.listProjectsAll.map((t, idx) => {
                                            return <MenuItem value={t.id} key={idx}  > {t.nume}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <FormControl className='inputFocus' >
                                    <InputLabel htmlFor="resursa">{this.dictionary.proiecte.numeUser}</InputLabel>
                                    <Select

                                        value={this.state.numeUser || ""}
                                        onChange={(ev) => { this.addUser(ev) }}

                                        input={<Input id="resursa" />}>


                                        {this.state.listUsersAll.map((t, idx) => {
                                            return <MenuItem value={t.id} key={idx}  > {t.nume}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid  item xs={12} sm={12} md={12} lg={12} xl={12} >
                               <h4 style={{ textAlign: 'left' }} className='pm-title'>Filtreaza dupa user:{this.state.listUsers.map((u,idx)=>{
                                   return(
                                    <Chip
                                    key={idx}
                                    style={{backgroundColor:new Utils().culoriProiecte(idx),
                                        color:'white', 
                                        marginLeft:5}}
                                    // avatar={<Avatar alt="Natacha" src="/static/images/avatar/1.jpg" />}
                                    label={u.nume}
                                    onDelete={()=>{this.removeFilterUser(u)}}
                                    deleteIcon={<i style={{color:'white'}} className='material-icons'>delete</i>}
                                  />
                                   )
                               })}</h4>

                            </Grid>
                            <Grid  item xs={12} sm={12} md={12} lg={12} xl={12} >
                               <h4 style={{ textAlign: 'left' }} className='pm-title'>Filtreaza dupa proiect:{this.state.listProjects.map((u,idx)=>{
                                   return(
                                    <Chip
                                    key={idx}
                                    style={{backgroundColor:new Utils().culoriProiecte(idx),
                                            color:'white',
                                            marginLeft:5}}
                                    // avatar={<Avatar alt="Natacha" src="/static/images/avatar/1.jpg" />}
                                    label={u.nume}
                                    onDelete={()=>{this.removeFilterProiect(u)}}
                                    deleteIcon={<i style={{color:'white'}} className='material-icons'>delete</i>}
                                  />
                                   )
                               })}</h4>

                            </Grid>



                        </Grid>
                        <FormControl className='inputFocus' style={{ width: 150, marginRight: 20, marginBottom: 20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.proiecte.rapoarteProiect.ordoneazaDupa}</InputLabel>
                            <Select

                                value={this.state.sortBy || ""}
                                onChange={(ev) => { this.sortBy(ev) }}

                                input={<Input id="resursa" />}>


                                {this.state.sortByList.map((t, idx) => {
                                    return <MenuItem value={t.id} key={idx}  > {t.nume}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>

                        <div style={{ marginTop: 30, marginBottom: 20, overflow: 'auto', width: '100%' }}>

                            <h2 className='pm-title'>Informatii Generale</h2>

                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.numeUser}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.numeProiect}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.numeTask}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.deLa}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.panaLa}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.durataOre}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreDepasire}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreAvans}
                                        </TableCell>
                                        <TableCell>
                                            Expl
                                         </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {this.state.listRaport.map((e, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nume_user}
                                                </TableCell>

                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nume_proiect}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.nume_task}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.dela !== 'null' ? new Utils().dataPrescurtataRomana(e.de_la) : ''}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.pana_la !== 'null' ? new Utils().dataPrescurtataRomana(e.pana_la) : ''}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.durata_ore}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.ore_depasire}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.ore_avans}
                                                </TableCell>


                                                <TableCell >
                                                    {e.ore_depasire !== '' &&
                                                        <span style={{ color: 'green' }}>Utilizatorul termina majoritatea taskurilor inainte de termen
                                    cu aproximativ {Number(((e.ore_depasire / e.durata_ore || 1) * 100).toFixed(2))}%.</span>}
                                                    {e.ore_avans !== '' &&
                                                        <span style={{ color: 'pink' }}>Utilizatorul de regula depaseste taskurile
                                    cu aproximativ {Number(((e.ore_avans / e.durata_ore || 1) * 100).toFixed(2))}%.</span>}
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}


                                </TableBody>
                            </Table>




                        </div>





                    </div>


                }
            </div>
        );
    }
}